import React from 'react'
import PropTypes from 'prop-types'
import { designSystem, ThemeProvider } from '@planningcenter/tapestry-react'

import * as logomark from '@planningcenter/icons/paths/logomark'
import * as api from '@planningcenter/icons/paths/api'

const { colors: defaultColors } = designSystem

const customizations = {
  primary: "#2266f7",
  'primary-dark': "#0e58f6",
  'primary-darker': "#0850e8",
  'primary-darkest': "#0742c0",
  'primary-light': "#6b99fa",
  'primary-lighter': "#d8e4fe",
  'primary-lightest': "#e1ebfe",
  separatorFocus: defaultColors['planning-center'],
  separatorFocusSecondary: 'primary-lighter',
  'beta-pink': '#FA7EA4',
  webhooks: '#639BCD',
  api: '#639BCD',
}

export const colors = {
  ...defaultColors,
  ...customizations,
}

export const breakpoints = {
  xs: 480,
  sm: 600,
  md: 720,
  lg: 960,
  xl: 1200,
}

const theme = {
  id: 'api-documentation',
  colors,
  breakpoints,
  button: {
    themes: {
      primary: {
        fill: {
          backgroundColor: 'primary',
          color: 'white',
          hover: {
            backgroundColor: 'primary-dark',
            color: 'white',
          },
        },
        outline: {
          stroke: 'primary',
          color: 'primary',
        },
      },
      plain: {
        fill: {
          backgroundColor: 'white',
          borderColor: 'grey-6',
          borderStyle: 'solid',
          borderWidth: '1px',
          color: 'grey-8',
          hover: {
            backgroundColor: 'grey-1',
            borderColor: 'grey-7',
            color: 'grey-8',
          },
        },
      },
    },
  },
  icons: { logomark, api },
}

const ThemeWrapper = ({ children }) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}

ThemeWrapper.propTypes = {
  children: PropTypes.node.isRequired,
}

export default ThemeWrapper
